import { useEffect, useRef } from 'react';

/**
 * Attiva ``onIntersect`` quando la ``sentinel`` entra in viewport
 * (uso classico per infinite scroll). Si auto-disabilita se
 * ``enabled=false``.
 */
export function useInfiniteScroll(
  sentinelRef: React.RefObject<HTMLElement>,
  onIntersect: () => void,
  enabled: boolean,
) {
  const handlerRef = useRef(onIntersect);
  handlerRef.current = onIntersect;

  useEffect(() => {
    if (!enabled || !sentinelRef.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) handlerRef.current();
      },
      { threshold: 0.1, rootMargin: '120px' },
    );
    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [sentinelRef, enabled]);
}
